import React, { useEffect, useState } from "react";
import {
  Color,
  FontStyle,
  Slug,
  SurveyButtonStyle,
  navPaddingTop,
} from "../constants";
import { Avatar, Box, Button, CircularProgress, Stack } from "@mui/material";
import { JobBg } from "../components/JobPanels/jobLayoutElements";
import LogoBubble from "../components/LogoBubble";

// mimic NoReferralSplash's splash page (because we like the design)
// but no affiliate, so don't load affiliate data
// standard only (no gig)

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    ...FontStyle.body,
  },
  li: {
    marginBottom: "14px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "18px",
  },
};

const CircleNumber = ({ number }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: "30px",
        minWidth: "30px",
        height: "30px",
        borderRadius: "50%",
        backgroundColor: Color.primary,
      }}>
      {number}
    </Stack>
  );
};

const GigSplash = ({ to }) => {
  return (
    <Box
      sx={{
        ...styles.outer,
        // position: "relative",
        width: "100%",
        // top: navPaddingTop,
        // // height: "100%",
        // // height: "100vh",
        // minHeight: "calc(100vh - 100px)",
      }}>
      <JobBg />
      <Stack
        direction="column"
        spacing={2}
        alignItems="center"
        sx={{
          padding: { xs: "20px", sm: "36px" },
          // border: "1px solid black",
          backgroundColor: "white",
          // height: "100%",
          height: "fit-content",
          borderRadius: "10px",
          maxWidth: { xs: "calc(100% - 64px)", sm: "550px" },
          width: "100%",
          // margin: "auto",
          position: "absolute",
          top: "calc(50%)",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 3px 10px 0px rgba(0,0,0,0.25)",
        }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ width: "100%" }}>
          <LogoBubble size="128px" />
        </Stack>
        <Box
          sx={{
            paddingTop: "8px",
            fontSize: "20px",
            textAlign: "center",
          }}>
          <i>
            <b>Looking for work?</b> Fill out this 2 minute survey to get
            matched with hundreds of jobs instantly
          </i>
          !
        </Box>
        <Box>
          <ol
            style={{
              fontSize: "16px",
              lineHeight: "1.5em",
              paddingLeft: "20px",
              // remove number
              listStyleType: "none",
            }}>
            <li style={styles.li}>
              {" "}
              <CircleNumber number={1} />
              Fill out this 2 minute survey
            </li>
            <li style={styles.li}>
              <CircleNumber number={2} />
              Fetti will instantly match your job preferences with hundreds of
              eligible jobs
            </li>
            <li style={styles.li}>
              <CircleNumber number={3} />
              Apply to jobs with one click!
            </li>
          </ol>
        </Box>
        <a href={to} style={{ width: "100%" }}>
          <Button
            sx={{
              ...SurveyButtonStyle.defaultStyling,
              ...SurveyButtonStyle.primaryColorScale,
            }}
            disableRipple
            fullWidth>
            LET'S GO
          </Button>
        </a>
      </Stack>
    </Box>
  );
};

const NoReferralSplash = () => {
  const destination = Slug.surveyInitial;

  return <GigSplash to={destination} />;
};

export default NoReferralSplash;
